import { type Method, Methods } from './methods.js';

export type MethodEffect = 'read' | 'write';

const READ_METHODS = new Set<Method>([
  Methods.Tokens,
  Methods.TokensHistory,
  Methods.Media,
  Methods.MediaSearch,
  Methods.MediaTags,
  Methods.MediaActive,
  Methods.MediaHistory,
  Methods.MediaHistoryLatest,
  Methods.MediaHistoryTop,
  Methods.MediaLookup,
  Methods.MediaMeta,
  Methods.MediaImage,
  Methods.Scrapers,
  Methods.MediaScrapeStatus,
  Methods.MediaBrowse,
  Methods.MediaBrowseIndex,
  Methods.MediaTitleParse,
  Methods.Settings,
  Methods.SettingsLogsDownload,
  Methods.SettingsBackupList,
  Methods.SettingsBackupInspect,
  Methods.SettingsBackupStatus,
  Methods.SettingsBackupRemoteList,
  Methods.PlaytimeLimits,
  Methods.Playtime,
  Methods.Clients,
  Methods.ClientsCurrent,
  Methods.Profiles,
  Methods.ProfilesActive,
  Methods.ProfilesVerify,
  Methods.Systems,
  Methods.Launchers,
  Methods.Mappings,
  Methods.Readers,
  Methods.Version,
  Methods.Health,
  Methods.Inbox,
  Methods.SettingsAuthStatus,
  Methods.SettingsAuthLinkStatus,
  Methods.UpdateCheck,
  Methods.Screenshot,
  Methods.UI,
]);

const WRITE_METHODS = new Set<Method>([
  Methods.Launch,
  Methods.Run,
  Methods.Stop,
  Methods.Confirm,
  Methods.UIRespond,
  Methods.MediaGenerate,
  Methods.MediaGenerateCancel,
  Methods.MediaGenerateResume,
  Methods.MediaIndex,
  Methods.MediaTagsUpdate,
  Methods.MediaMetaUpdate,
  Methods.MediaScrape,
  Methods.MediaScrapeCancel,
  Methods.MediaScrapeResume,
  Methods.MediaControl,
  Methods.MediaActiveUpdate,
  Methods.MediaCleanOrphans,
  Methods.SettingsUpdate,
  Methods.SettingsReload,
  Methods.SettingsBackup,
  Methods.SettingsBackupDelete,
  Methods.SettingsBackupRestore,
  Methods.SettingsBackupRemoteRun,
  Methods.SettingsBackupRemoteRestore,
  Methods.PlaytimeLimitsUpdate,
  Methods.ClientsDelete,
  Methods.ClientsPairStart,
  Methods.ClientsPairCancel,
  Methods.ProfilesNew,
  Methods.ProfilesUpdate,
  Methods.ProfilesDelete,
  Methods.ProfilesSwitch,
  Methods.LaunchersRefresh,
  Methods.MappingsNew,
  Methods.MappingsDelete,
  Methods.MappingsUpdate,
  Methods.MappingsReload,
  Methods.ReadersWrite,
  Methods.ReadersWriteCancel,
  Methods.InboxDelete,
  Methods.InboxClear,
  Methods.SettingsAuthClaim,
  Methods.SettingsAuthUnlink,
  Methods.SettingsAuthLink,
  Methods.SettingsAuthLinkCancel,
  Methods.UpdateApply,
  Methods.InputKeyboard,
  Methods.InputGamepad,
]);

export function methodEffect(method: string): MethodEffect {
  if (READ_METHODS.has(method as Method)) return 'read';
  return 'write';
}

export function isKnownMethod(method: string): method is Method {
  return READ_METHODS.has(method as Method) || WRITE_METHODS.has(method as Method);
}

export function methodAccessCatalog(): Record<Method, MethodEffect> {
  const catalog = {} as Record<Method, MethodEffect>;
  for (const method of READ_METHODS) catalog[method] = 'read';
  for (const method of WRITE_METHODS) catalog[method] = 'write';
  return catalog;
}
